var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSpeakerNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.82 5.49414C19.8191 6.42582 20.6167 7.55234 21.1636 8.80419C21.7105 10.056 21.9952 11.4067 21.9999 12.7728C22.0047 14.1389 21.7295 15.4915 21.1914 16.7471C20.6532 18.0027 19.8635 19.1348 18.8709 20.0734M16.092 8.41956C16.6915 8.97856 17.17 9.65447 17.4982 10.4056C17.8263 11.1567 17.9971 11.9671 18 12.7867C18.0028 13.6064 17.8377 14.4179 17.5148 15.1713C17.1919 15.9247 16.7181 16.6039 16.1225 17.1671M7.4803 16.2145L9.15553 18.2876C10.0288 19.3683 10.4655 19.9087 10.848 19.9675C11.1792 20.0184 11.5138 19.9001 11.7394 19.6524C12 19.3662 12 18.6715 12 17.282V8.33334C12 6.94389 12 6.24917 11.7394 5.96298C11.5138 5.71523 11.1792 5.59691 10.848 5.64783C10.4655 5.70665 10.0288 6.247 9.15553 7.32771L7.4803 9.40081C7.30388 9.61913 7.21567 9.72829 7.10652 9.80684C7.00982 9.87643 6.90147 9.92818 6.78656 9.95965C6.65687 9.99518 6.51652 9.99518 6.23583 9.99518H4.8125C4.0563 9.99518 3.6782 9.99518 3.37264 10.0961C2.77131 10.2948 2.2996 10.7665 2.10094 11.3678C2 11.6734 2 12.0515 2 12.8077C2 13.5639 2 13.942 2.10094 14.2475C2.2996 14.8489 2.77131 15.3206 3.37264 15.5192C3.6782 15.6202 4.0563 15.6202 4.8125 15.6202H6.23583C6.51652 15.6202 6.65687 15.6202 6.78656 15.6557C6.90147 15.6872 7.00982 15.7389 7.10652 15.8085C7.21567 15.8871 7.30388 15.9962 7.4803 16.2145Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeakerNone);
export default __webpack_public_path__ + "static/media/ic_speaker_none.4fd1452709ac5421ac2cf23aa2fa9f1e.svg";
export { ForwardRef as ReactComponent };